<template>
  <div
    v-if="$store.getters.marchand && $store.getters.marchand._env === 'live'"
    class="row"
    style="padding: 5px"
  >
    <div class="col-12 mb-4">
      <div class="pb-4">
        <v-btn
          @click="$router.go(-1)"
          outlined
          style="border: none; background: #fff"
          title="Retourner"
        >
          <v-icon>mdi mdi-arrow-left-thin</v-icon> Retour
        </v-btn>
      </div>
      <h4>Frais de réduction de {{ student?._firstName }}</h4>
      <v-row>
        <v-col
          v-for="(item, index) in studentFees"
          :key="index"
          cols="12"
          sm="6"
          md="3"
        >
          <v-card
            style="background-color: white !important; cursor: pointer"
            class="p-2"
          >
            <!-- Top row with image, name, and menu -->
            <v-row align="center" no-gutters>
              <v-col class="px-4 pt-3">
                <h3 class="text-lg">
                  {{ item._fee && item._fee._name ? item._fee._name : "N/A" }}
                </h3>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="pr-4">
                <v-btn
                  x-small
                  dark
                  color="orange"
                  fab
                  outlined
                  class="mx-2"
                  @click="editItemAction(item, 0)"
                >
                  <v-icon small>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn
                  x-small
                  dark
                  outlined
                  color="pink"
                  fab
                  @click="editItemAction(item, 1)"
                >
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-card-text class="py-0">
              <v-col class="text-left px-0">
                <h6>
                  <v-icon small>mdi-chevron-triple-down</v-icon> Reduction :
                  <span style="color: black"> {{ item._value }} XOF</span>
                </h6>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <div @click="dialogCustomer = true" class="add_btn">
            <div class="text-center" style="font-size: 15pt">
              Configurer une réduction
            </div>
          </div>
        </v-col>
      </v-row>

      <v-dialog v-model="dialogCustomer" max-width="700px">
        <v-card>
          <v-card-text>
            <v-form ref="clientForm" v-model="clientFormIsValid">
              <v-container v-show="classestep === 1">
                <h3 class="pb-5 pt-5">Ajouter un nouveau frais</h3>
                <!-- <h4 style="font-weight:bold">
                                       Informations l'école
                                      </h4> -->

                <p>
                  Ce formulaire vous donne la possibilité d'appliquer des
                  réductions spécifiques à chaque frais associé à l'élève ou
                  l'étudiant.
                </p>
                <v-row>
                  <v-col lg="6">
                    <label for="">Choisir le frais</label>
                    <v-autocomplete
                      :rules="requiredRules"
                      v-model="feeToSave._fee"
                      item-value="_id"
                      :items="classes"
                      label="Sélectionnez un frais"
                      item-text="_name"
                      solo
                      persistent-hint
                    >
                    </v-autocomplete>
                    <span>
                      {{
                        feeToSave._fee
                          ? "Valeur: " +
                            classes.find((c) => c._id === feeToSave._fee)
                              ._defaultValue
                          : ""
                      }}
                    </span>
                  </v-col>

                  <v-col lg="6">
                    <label for="">Montant à reduire</label>
                    <v-text-field
                      solo
                      v-model="feeToSave._value"
                      type="number"
                      label="Montant"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="dark"
              @click="(dialogCustomer = false), (editingCustomer = false)"
            >
              Annuler
            </v-btn>

            <v-btn
              v-if="!editingCustomer"
              :loading="loadings.fee_saving"
              color="primary"
              :disabled="feeToSave._name === null || feeToSave._value === null"
              @click="saveFee()"
            >
              Enregistrer
            </v-btn>
            <v-btn
              v-if="editingCustomer"
              :loading="loadings.fee_saving"
              :disabled="feeToSave._name === null || feeToSave._value === null"
              color="primary"
              @click="updateFee()"
            >
              Mettre à jour
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import GoToParams from "../administrators/globalComponents/GoToParams";
import { client } from "../../store/services/client";
import { client as webservice_client } from "../../store/services/webservices-client";
import { fontAwesomePicker } from "font-awesome-picker";
import Swal from "sweetalert2";

export default {
  components: {
    GoToParams,
    "font-awesome-picker": fontAwesomePicker,
  },
  label: "Customers",
  data() {
    return {
      classestep: 1,
      transaction_name: "",
      currentProduct: null,
      currentQuantity: 1,
      editingCategory: false,
      editingCustomer: false,
      categoryClienFormIsValid: false,
      clientFormIsValid: false,
      selected_client_transaction: [],
      selected_category_client: [],
      transactionInProgress: false,
      requiredRules: [(v) => !!v || "Ce champ est recquis"],
      loadings: {
        classes: false,
        categories: false,
        categoriySaving: false,
        fee_saving: false,
      },
      whatsapp: "",
      tel: "",
      studentFees: undefined,
      notifier_whatsapp: "",
      notifier_tel: "",
      dialogTransaction: false,
      produits: [],
      classes: undefined,
      schoolClass: undefined,
      fees: [],
      school: undefined,
      all_classes: undefined,
      forCategoryClient: false,
      products: [],
      transaction_produits: [],
      client_transaction: null,
      status_transaction: false,
      dialogDeleteCategory: false,
      dialogDelete: false,
      country_key: "",
      lazy: false,
      errors: {},
      search: "",
      dialogCategory: false,
      dialogCustomer: false,
      id: undefined,
      customers_tabs: "",
      student: undefined,
      feeToSave: {
        _student: "",
        _fee: "",
        _value: "",
      },
      headers: [
        { text: "Nom", value: "_fee._name" },
        { text: "Valeur", value: "_value" },
        { text: "", value: "actions" },
      ],
      transaction_products: [],
      editedIndex: -1,
      editedItem: {},
      user_role: "",
      actions_items: [
        // {title: "Créer transaction", avatar: 'mdi-currency-usd'},
        { title: "Modifier", avatar: "mdi-pencil" },
        { title: "Supprimer", avatar: "mdi-delete" },
      ],

      categories_actions_items: [
        { title: "Modifier", avatar: "mdi-pencil" },
        { title: "Supprimer", avatar: "mdi-delete" },
      ],
      categories: [],
      category: {
        _name: "",
        _description: "",
      },
    };
  },
  computed: {
    // ...mapState('users/', ['classes']),
    dialogCategoryTitle() {
      if (this.editingCategory) return "Modification de catégorie client";

      return "Ajout d'une catégorie de client";
    },
    drop_down_user_countries: function () {
      let arr = [{ text: "Tous les utilisateurs", value: -1 }];

      if (this.countries) {
        this.countries.forEach((country) => {
          arr.push({ text: country._name, value: country._id });
        });
      }

      return arr;
    },
    ...mapState("countries/", ["countries"]),
    formCategoryTitle() {
      return "";
    },
  },
  mounted() {
    this.initialize();
    this.$store.dispatch("countries/getCountries").then((response) => {});
  },
  sockets: {
    connect: function () {
      console.log("socket to notification channel connected");
    },
  },
  methods: {
    // getphoneresult($event){

    //     this.feeToSave._contactNumber = $event.countryCallingCode + $event.nationalNumber
    // },
    getWhatsappresult($event) {
      this.customer._whatsapp = $event.nationalNumber;
    },
    getnotifierphoneresult($event) {
      this.customer._notifier_phone = $event.nationalNumber;
      this.customer._notifier_prefix = $event.countryCallingCode;
    },
    getnotifierWhatsappresult($event) {
      this.customer._notifier_whatsapp = $event.nationalNumber;
    },
    editItemAction(item, index) {
      switch (index) {
        // case 0:
        //   this.dialogTransaction = true;
        //   this.selected_client_transaction.push(item._id);
        //   break;
        case 0:
          this.toggleEditSchool(item);
          break;
        case 1:
          this.toggleDeleteFee(item);
          break;
      }
    },
    getAmountFromChoosenProduct(products) {
      let amount = 0;
      products.forEach((row) => {
        amount += row.product._price * row._quantity;
      });

      return amount;
    },
    async saveTransaction() {
      this.transactionInProgress = true;
      const data = {
        transaction_name: this.transaction_name,
        forCategoryClient: this.forCategoryClient,
        _classes: this.selected_client_transaction,
        _products: this.transaction_products,
        _categories: this.selected_category_client,
        _fees_support: this.fees_support,
        _amount: 0,
      };
      const amount = this.getAmountFromChoosenProduct(data._products);
      data._amount = amount;

      // save the transaction in backend
      const response = await client({
        method: "post",
        url: "/marchand/client_transaction",
        data: {
          data: data,
        },
      })
        .then((res) => res.data)
        .catch((error) => {
          return {
            error: true,
          };
        });

      if (!response.error) {
        this.dialogTransaction = false;
        this.resetTransaction();
      }
      this.transactionInProgress = false;
      this.toast(response.type, response.message);
    },
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    addProductToTransaction() {
      if (!this.currentProduct) return;
      const exist = this.transaction_products.filter(
        (x) => x.product._id === this.currentProduct._id
      );

      if (exist && exist.length > 0) {
        const index = this.transaction_products.indexOf(exist[0]);

        this.transaction_products[index].settings._quantity +=
          this.currentQuantity;
      } else {
        this.transaction_products.push({
          product: this.currentProduct,
          _product_id: this.currentProduct._id,
          _quantity: this.currentQuantity,
          settings: {
            _quantity: this.currentQuantity,
          },
        });
      }
    },
    async getMarchanProducts() {
      const response = await client({
        method: "get",
        url: "/marchand/product/get",
      })
        .then((resp) => resp.data)
        .catch((error) => {
          console.log(error);
          return {
            error: "true",
          };
        });
      if (!response.error) {
        this.products = response.products;
      }
    },
    async initialize() {
      if (this.$store.getters.marchand) {
        this.getAllStudentReductionFees();
        this.getAllClassFees();
        this.getStudent();
      }

      //   this.getMarchandCustomers()
      // else
      //   this.getAllclasses()

      // this.getMarchanProducts()
      // this.getCategories()
      // this.getAllMarchandCustomers();
    },

    async getStudent() {
      console.log("coming here");
      const response = await client({
        method: "get",
        url: `/school-payments/students/${this.$route.params.student_id}`,
      })
        .then((resp) => resp.data)
        .catch(() => {
          return {
            error: "true",
          };
        });
      if (!response.error) this.student = response;

      console.log(this.student);
    },

    async getAllMarchandCustomers() {
      const response = await client({
        method: "get",
        url: "marchand/marchand_customer/get",
      })
        .then((resp) => resp.data)
        .catch(() => {
          return {
            error: "true",
          };
        });
      if (!response.error) this.all_classes = response.marchandclasses;
    },
    async getAllStudentReductionFees() {
      this.loadings.classes = true;
      const response = await client({
        method: "get",
        url: `/school-payments/reductions/student/${this.$route.params.student_id}`,
      })
        .then((resp) => resp.data)
        .catch((error) => {
          this.loadings.classes = false;
          return {
            error: "true",
          };
        });
      if (!response.error) {
        this.loadings.classes = false;
        console.log(response);

        this.studentFees = response;

        console.log(this.studentFees);
      }
    },

    async getAllClassFees() {
      this.loadings.classes = true;
      const response = await client({
        method: "get",
        url: `/school-payments/class-fee/class/${this.$route.params.class_id}`,
      })
        .then((resp) => resp.data)
        .catch((error) => {
          this.loadings.classes = false;
          return {
            error: "true",
          };
        });
      if (!response.error) {
        this.loadings.classes = false;
        console.log(response);

        this.classes = response;

        console.log(this.classes);
      }
    },
    async getAllFees() {
      this.loadings.classes = true;
      const response = await client({
        method: "get",
        url: `/school-payments/fees/school/${this.$route.params.school_id}`,
      })
        .then((resp) => resp.data)
        .catch((error) => {
          this.loadings.classes = false;
          return {
            error: "true",
          };
        });
      if (!response.error) {
        this.loadings.classes = false;
        console.log(response);

        this.fees = response.filter((fee) => fee._defaultValue == null);

        console.log(this.fees);
      }
    },
    async getCategories() {
      this.loadings.categories = true;
      const response = await client({
        method: "get",
        url: "/client_category/get",
      })
        .then((resp) => resp.data)
        .catch((error) => {
          this.loadings.categories = false;
          return {
            error: "true",
          };
        });
      if (!response.error) {
        this.loadings.categories = false;
        this.categories = response.categories;
      }
    },
    async saveFee() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.fee_saving = true;
        this.feeToSave._student = this.$route.params.student_id;
        this.feeToSave._value = parseFloat(this.feeToSave._value);
        const response = await client({
          method: "post",
          url: "/school-payments/reductions/",
          data: this.feeToSave,
        })
          .then((resp) => {
            this.$refs.clientForm.reset();
            console.log(resp.data);
            return resp.data;
          })
          .catch((error) => {
            return {
              error: "true",
            };
          });
        this.loadings.fee_saving = false;
        this.dialogCustomer = false;
        this.getAllStudentReductionFees();
        this.toast(response.type, response.message);
      }
    },
    async saveMassCustomer() {
      this.sheetSaving = true;
      let data = new FormData();
      data.append("sheet", this.sheet);
      data.append("type", this.type_import);
      const response = await client({
        method: "post",
        url: "/marchand_customer/post/sheet",
        data: data,
      })
        .then((resp) => {
          this.sheet = [];
          return resp.data;
        })
        .catch((error) => {
          return {
            error: "true",
          };
        });
      this.dialogSheetUpload = false;
      this.sheetSaving = false;
      this.getMarchandCustomers();
      this.getCategories();
      this.toast(response.type, response.message);
    },
    async saveCategory() {
      if (this.$refs.categoryClienForm.validate()) {
        this.loadings.categoriySaving = true;
        const response = await client({
          method: "post",
          url: "/client_category/post",
          data: this.category,
        })
          .then((resp) => {
            this.categories = resp.data.categorieclasses;
            this.$refs.categoryClienForm.reset();
            return resp.data;
          })
          .catch((error) => {
            return {
              error: "true",
            };
          });
        this.loadings.categoriySaving = false;
        this.dialogCategory = false;
        this.toast(response.type, response.message);
      }
    },

    async updateFee() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.fee_saving = true;
        const response = await client({
          method: "PUT",
          url: `/school-payments/fees/${this.id}`,
          data: this.feeToSave,
        })
          .then((resp) => {
            this.$refs.clientForm.reset();
            return resp.data;
          })
          .catch((error) => {
            return {
              error: "true",
            };
          });
        this.loadings.fee_saving = false;
        this.editingCustomer = false;
        this.dialogCustomer = false;
        this.getAllStudentReductionFees();
        this.toast(response.type, response.message);
      }
    },
    toggleEditSchool(item) {
      this.dialogCustomer = true;
      this.editingCustomer = true;
      this.feeToSave = item;
      this.id = item._id;
      console.log(this.id);
    },
    editCategoryItemAction(item, index) {
      switch (index) {
        case 0:
          this.toggleEdtiCategory(item);
          break;
        case 1:
          this.toggleDeleteCategory(item);
          break;
      }
    },
    toggleEdtiCategory(item) {
      this.dialogCategory = true;
      this.editingCategory = true;
      this.category = item;
    },
    toggleDeleteCategory(item) {
      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t("delete_warning"),
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        cancelButtonColor: "#CCC",
        confirmButtonColor: "#29B3A6",
        preConfirm: async () => {
          Swal.showLoading();
          return (response = await client({
            method: "get",
            url: `/client_category/delete/${item._id}`,
          })
            .then((resp) => {
              Swal.hideLoading();
              Swal.fire({
                icon: "success",
                text: "Suppression réussi",
                confirmButtonText: "Ok",
                cancelButtonText: "Annuler",
                cancelButtonColor: "#CCC",
                confirmButtonColor: "#29B3A6",
              });
              this.categories = resp.data.categorieclasses;
              return resp.data;
            })
            .catch((error) => {
              return {
                error: "true",
              };
            }));
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        if (result.value) {
        }
      });
    },
    resetTransaction() {
      this.transaction_name = "";
      this.forCategoryClient = false;
      this.selected_client_transaction = [];
      this.transaction_products = [];
      this.selected_category_client = [];
      (this.currentProduct = null),
        (this.currentQuantity = 1),
        (this.allTransaction = []),
        (this.dialogTransaction = false);
      this.fees_support = false;
    },
    toggleDeleteFee(item) {
      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t("delete_warning"),
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        cancelButtonColor: "#CCC",
        confirmButtonColor: "#29B3A6",
        preConfirm: async () => {
          Swal.showLoading();
          try {
            const response = await client({
              method: "delete",
              url: `/school-payments/fees/${item._id}`,
            });
            Swal.hideLoading();
            Swal.fire({
              icon: "success",
              text: "Suppression réussi",
              confirmButtonText: "Ok",
              cancelButtonText: "Annuler",
              cancelButtonColor: "#CCC",
              confirmButtonColor: "#29B3A6",
            });
            console.log(response);
            await this.getAllStudentReductionFees();
            return response.data;
          } catch (error) {
            Swal.hideLoading();
            Swal.fire({
              icon: "error",
              text: "Erreur lors de la suppression",
              confirmButtonText: "Ok",
              cancelButtonText: "Annuler",
              cancelButtonColor: "#CCC",
              confirmButtonColor: "#29B3A6",
            });
            return { error: "true" };
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          console.log("finish with modal");
          this.getAllStudentReductionFees();
        }
      });
      console.log("finish with modal 2");
    },
    goToUserDetails(id) {
      let url = "/users/" + id;
      this.$router.push(url);
    },
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },
    deleteItemConfirm() {},
    selectCategoryCustomerIcon(icon) {
      this.category._icon = icon.className;
    },
    filterUsers(criteria) {
      let VueBox = this;
      this.$store.dispatch("users/filterClient", {
        country_id: VueBox.country_key,
        isMarchand: VueBox.$store.getters.marchand !== null,
      });
    },
    getClass(item) {
      return `fa fa-2xl fa-${item._icon}`;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
  created() {
    this.checkisDashboard();
    this.initialize();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style scoped>
.circular--square {
  border-radius: 50%;
}

.circular--square {
  border-radius: 50% 50%;
  width: 50px;
  height: 50px;
  object-fit: contain;
}
svg:not(:host).svg-inline--fa,
svg:not(:root).svg-inline--fa {
  font-size: 20px;
}
</style>
